module.exports = __webpack_public_path__ + "img/title.6f866c50.png";